var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcClose = function SvgIcClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.897 10.063 12.46 12.5l2.437 2.437a.548.548 0 0 1 0 .793.544.544 0 0 1-.793 0l-2.437-2.437L9.23 15.73a.544.544 0 0 1-.397.17.544.544 0 0 1-.396-.17.548.548 0 0 1 0-.793l2.436-2.437-2.436-2.437a.548.548 0 0 1 0-.793.548.548 0 0 1 .793 0l2.437 2.437 2.436-2.437a.548.548 0 0 1 .794 0 .548.548 0 0 1 0 .793Zm5.27.17v4.534A6.24 6.24 0 0 1 13.933 21H9.4a6.24 6.24 0 0 1-6.233-6.233v-4.534A6.24 6.24 0 0 1 9.4 4h4.533a6.24 6.24 0 0 1 6.234 6.233Zm-1.134 0c0-2.814-2.285-5.1-5.1-5.1H9.4a5.103 5.103 0 0 0-5.1 5.1v4.534c0 2.814 2.286 5.1 5.1 5.1h4.533c2.815 0 5.1-2.286 5.1-5.1v-4.534Z",
    fill: "currentColor"
  })));
};
export default SvgIcClose;